<template>
  <div class="p-d03-details">
    <p class="p-d03-details__heading">お支払い内容</p>

    <dl class="p-d03-details__list" v-if="points.all >= 0">
      <dt class="p-d03-details__list__term">保有ポイント合計</dt>
      <dd class="p-d03-details__list__description">
        <PointNotation
          :point="points.all"
          :point-color="'#4f4f4f'"
          :sign-is-exists="false"
          class="p-d03-details__list__point"
        />
      </dd>
    </dl>

    <dl class="p-d03-details__list" v-if="points.use_point > 0">
      <dt class="p-d03-details__list__term">ご利用ポイント合計</dt>
      <dd class="p-d03-details__list__description">
        <PointNotation
          :point="points.use_point"
          :point-color="'#4f4f4f'"
          :sign-is-exists="false"
          class="p-d03-details__list__point"
        />
      </dd>
    </dl>

    <dl class="p-d03-details__list" v-if="points.use_creditcard > 0">
      <dt class="p-d03-details__list__term">クレジット決済金額</dt>
      <dd class="p-d03-details__list__description">
        <PointNotation
          :point="points.use_creditcard"
          :point-color="'#4f4f4f'"
          :unit="{ point: '円' }"
          :sign-is-exists="false"
          class="p-d03-details__list__point"
        />
        <p class="p-d03-details__list__description__addition">
          （価格：{{ addComma(points.use_creditcard_excluding_tax) }}円／
          消費税{{ addComma(points.use_creditcard_tax) }}円）
          <br />
          <span v-if="points.use_creditcard_tax_rate > 0">
            消費税率：{{ points.use_creditcard_tax_rate }}％
          </span>
        </p>
      </dd>
    </dl>

    <dl class="p-d03-details__list" v-if="points.after_subtraction >= 0">
      <dt class="p-d03-details__list__term">申込み後の残りのポイント</dt>
      <dd class="p-d03-details__list__description">
        <PointNotation
          :point="points.after_subtraction"
          :point-color="'#4f4f4f'"
          :sign-is-exists="false"
          class="p-d03-details__list__point"
        />
      </dd>
    </dl>
  </div>
</template>

<script lang="ts">
import commons from "@/common/store/modules/commons";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import { Options, Vue } from 'vue-class-component';
import { mapState } from "vuex";

@Options({
  props: {
    points: { type: Object, required: false }
  },
  components: {
    PointNotation
  }
})
export default class D03Details extends Vue {
  points!: any;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  //unit = commons.unit;
	addComma(value: any) {
	    const number = Number(value);
	    if (Number.isNaN(number)) {
	      return value;
	    }
	    return number.toLocaleString();
	}
}
</script>

<style lang="scss" scoped>
.p-d03-details {
  padding: rem(16);
  border: px(1) solid $common-gray-border;

  @include large-sp {
    margin-top: rem(40);
    padding: rem(14) rem(16);
  }

  &__heading {
    font-weight: bold;
    font-size: rem(14);
    line-height: (19/14);
  }

  &__list {
    margin-top: rem(8);

    &:first-child {
      margin-top: 0;
    }
    &__term {
      color: $common-gray500;
      font-size: rem(14);
      font-weight: bold;
      line-height: (19/14);
    }
    &__description {
      margin-top: rem(2);

      &__addition {
        font-size: rem(14);
        line-height: (17/14);
      }
    }

    // TODO: コンポーネント側のline-heightを制御できない。
    &__point {
      margin-top: -0.25em;
      margin-bottom: -0.25em;
    }
  }
}
</style>
